import styled from 'styled-components'

export const Wrapper = styled.div`
  .ant-steps {
    margin-bottom: 8px;
  }
  .ant-steps-item-active > div > div > div {
    font-weight: 700;
  }
  .ant-steps-item-wait > div > div > span,
  .ant-steps-item-wait > div > div > div {
    color: #262626 !important;
  }
  .ant-steps-icon > svg {
    background-color: #e7f3fe;
    border-radius: 32px;
    padding: 5px;
    width: 14px;
    height: 14px;
  }
`
